import { ReactElement, useEffect, useState } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';

/**
 * Text input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {number} props.maxLength optional number to be displayed with the current character count in label
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {object} props.props the rest of the props
 * @returns Text input stylized for custom
 */
const AppWrappedTextbox = ({
	setLoading,
	label,
	maxLength,
	formik,
	helperText,
	isRequired = false,
	isLoading = false,
	...props
}) => {
	const [countLabel, setCountLabel] = useState(` (0/${maxLength})`);

	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	useEffect(() => {
		if (
			maxLength &&
			formik?.values &&
			props.name in formik.values &&
			formik.values[props.name].length >= 0
		) {
			setCountLabel(
				` (${formik.values[props.name].length}/${maxLength})`
			);
			//set touched to force validation to run
			if (formik.values[props.name].length > maxLength) {
				formik.setFieldTouched(props.name, true);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [formik?.values]);

	return (
		<AppWrappedInput
			label={label}
			error={
				formik?.touched[props.name] ? formik?.errors[props.name] : null
			}
			isRequired={isRequired}
		>
			<FormControl variant='filled' fullWidth>
				<TextField
					fullWidth
					variant='filled'
					label={'Provide ' + label + (maxLength ? countLabel : '')}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					value={formik.values[props.name]}
					name={props.name}
					{...props}
				/>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedTextbox);
